<template>
  <div :style="{ color: color }">
    {{ label }}<span class="required">{{ isRequired ? '*' : '' }}</span>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    isRequired: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: 'black',
    },
  },
}
</script>
<style scoped>
.required {
  color: red;
}
</style>
